interface AnchoredOverlayPositionArgs {
    anchorRect: DOMRect;
    panelWidth: number;
    panelHeight: number;
    gap?: number;
    padding?: number;
}

export const getAnchoredOverlayPosition = ({
    anchorRect,
    panelWidth,
    panelHeight,
    gap = 12,
    padding = 16,
}: AnchoredOverlayPositionArgs) => {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let left = anchorRect.right + gap;
    if (left + panelWidth > viewportWidth - padding) {
        left = anchorRect.left - panelWidth - gap;
    }
    left = Math.max(padding, Math.min(left, viewportWidth - panelWidth - padding));

    let top = anchorRect.top;
    if (top + panelHeight > viewportHeight - padding) {
        top = viewportHeight - panelHeight - padding;
    }
    top = Math.max(padding, top);

    return { left, top };
};
